import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface Discipline {
  _id?: string;
  eleve: string[];
  type: string;
  texte: string;
  editeur: string;
  date: string;
  classe: string;
  fichier_base64_string: string;
  fichier_extension: string;
  fichier: string;
}

export const disciplineSlice = createApi({
  reducerPath: "Discipline",
  baseQuery: baseQueryWithAuth("disciplines"),
  tagTypes: ["Discipline"],
  endpoints(builder) {
    return {
      fetchDisciplines: builder.query<Discipline[], number | void>({
        query() {
          return `/getDisciplines`;
        },
        providesTags: ["Discipline"],
      }),
      getDisciplinesByEleveId: builder.mutation<Discipline[], string | void>({
        query: (id) => ({
          url: `/discipline-eleve-id/${id}`,
          method: "GET",
        }),
        invalidatesTags: ["Discipline"],
      }),
      addDiscipline: builder.mutation<void, Discipline>({
        query(payload) {
          return {
            url: "/newDiscipline",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["Discipline"],
      }),
      updateDiscipline: builder.mutation<void, Discipline>({
        query: ({ _id, ...rest }) => ({
          url: `/updateDiscipline/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["Discipline"],
      }),
        deleteDiscipline: builder.mutation<void, Discipline>({
          query: (_id) => ({
            url: `/deleteDiscipline/${_id}`,
            method: "Delete",
          }),
          invalidatesTags: ["Discipline"],
        }),
        bulkDeleteDisciplines: builder.mutation<{ deleted: number }, string[]>({
          query(ids) {
            return {
              url: "/bulkDelete",
              method: "POST",
              body: { ids },
            };
          },
          invalidatesTags: ["Discipline"],
        }),
    };
  },
});

export const { useAddDisciplineMutation, useFetchDisciplinesQuery, useDeleteDisciplineMutation, useGetDisciplinesByEleveIdMutation, useUpdateDisciplineMutation, useBulkDeleteDisciplinesMutation } =
  disciplineSlice;
